import { BrowserRouter, Routes, Route } from "react-router-dom";
import IframeReservationForm from "../components/IframeReservationForm";
import IframeBasicReservation from "../components/IframeBasicReservation";
import IframeBookingReservation from "../components/IframeBookingReservation";
import IframeLessonsReservation from "../components/IframeLessonsReservation";
import IframeMainPage from "../components/IframeMainPage";

const IframeAllPages = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/business/public/:businessId/reservationform" element={<IframeReservationForm />} />
        <Route path="/business/public/:businessId/basicreservation/reservationform" element={<IframeBasicReservation />} />
        <Route path="/business/public/:businessId/bookingreservation/reservationform" element={<IframeBookingReservation />} />
        <Route path="/business/public/:businessId/lessonsreservation/reservationform" element={<IframeLessonsReservation />} />
        <Route path="/business/public/:businessId/mainpage/reservationform" element={<IframeMainPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default IframeAllPages
